import { getBigLen, bigSubstring, getStringByLength } from './StringUtil';

/**
 *
 * @param sourceSize 字节数
 * @param bit 小数位数
 * @returns {number}
 */

export function bytesToSize(sourceSize: string | number, bit: number = 2) {
  let size: any = Number(sourceSize);
  if (typeof size === 'number') {
    if (isNaN(size) || size < 0) {
      size = '0KB';
      return size;
    }
    const unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let int = 0;
    for (int = 0; size >= 1024; int += 1) {
      size = size / 1024;
    }
    size = size.toFixed(bit) + unit[int];
  } else {
    size = '0KB';
  }
  return size;
}

/**
 * 获取文件类型图片
 * @param fileName
 */
export function getFileTypeByName(fileName: string = '') {
  let type = 'file';
  if (fileName) {
    const filePop = fileName.split('.').pop();
    if (filePop && filePop.length >= 2) {
      type = filePop.toLowerCase();
    }
  }
  // const types = ['7z', 'doc', 'dwg', 'pdf', 'png', 'jpg', 'ppt', 'rar', 'txt', 'xls', 'zip'];
  const types = ['doc', 'dwg', 'pdf', 'ppt', 'rar', 'xls', 'zip'];
  switch (type) {
    case 'docx':
      type = 'doc';
      break;
    case 'pptx':
      type = 'ppt';
      break;
    case 'xlsx':
      type = 'xls';
      break;
    case 'zip':
    case 'rar':
      type = 'rar';
      break;
    default:
      if (types.indexOf(type) < 0) {
        type = 'file';
      }
      break;
  }
  return type;
}

/**
 * 根据语音的音轨长度来制定消息显示的长度
 * @param trackLength
 * @returns {span标签的长度}
 */
export function getVoiceLength(trackLength: number) {
  const minSpanLength = 50;
  const maxSpanLength = 290;
  const pro = (maxSpanLength - minSpanLength) / 60;
  let spanLength = minSpanLength + (trackLength - 1) * pro;
  if (spanLength >= maxSpanLength) {
    spanLength = maxSpanLength;
  }
  return spanLength;
}

/**
 * 替换文件名中超出长度范围的字符（中文2个字符，英文1个字符）
 * 将文件名（排除后缀名）超过长度限制的字符替换为...
 * @param fullName
 * @param length 文件名截取的长度
 * @returns {string}
 */
export function replaceFileNameOutRange(fullName: string = '', length: number = 60) {
  const sepIndex = fullName.lastIndexOf('.'); // 后缀分隔符下标
  const suffix = fullName.substring(sepIndex + 1); // 后缀名
  const fileName = fullName.substring(0, sepIndex) || ''; // 文件名

  if (getBigLen(fileName) > length) {
    return `${bigSubstring(fileName, length)}...${suffix}`;
  }
  return fullName;
}

export function dataURLtoBlob(dataurl: string) {
  try {
    const arr = dataurl.split(',');
    const mime: RegExpMatchArray | null = arr[0].match(/:(.*?);/);
    let temp = '';
    if (mime) {
      temp = mime[1];
    }
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: temp });
  } catch (error) {
    return null;
  }
}
/**
 * 文件名显示，最后4位显示（不包括类型）
 * @param name
 * @param maxLen
 */
export function getLengthValidateFileName(name: string = '', maxLen: number = 60) {
  // 没有后缀
  if (name.indexOf('.') <= -1) {
    return replaceFileNameOutRange(name, maxLen);
  }

  const temp = name.split('.') || [];
  const type = temp.pop();
  const prefText = temp.join('.');
  let fileName = prefText.slice(0, -4);
  const lastString = prefText.slice(-4);
  if (maxLen) {
    fileName = getStringByLength(fileName, maxLen);
  }
  return `${fileName}${lastString}.${type}`;
}

export function getFileType(fileName: string) {
  if (!fileName) {
    return '';
  }
  const temp = fileName.split('.'); // 后缀分隔符下标
  if (temp.length > 1) {
    return temp.pop() || '';
  }
  return '';
}
